// components
import dataIntegrityReducer from '@/features/energyxplorer/redux/dataIntegritySlice';
import timeRangeReducer from '@/features/energyxplorer/redux/timeRangeSlice';

// relative
import {
  adminApiSlice,
  adressevaelgerApiSlice,
  apiSliceV2,
  apiSliceV2Generated,
  authServerApiSlice,
  cvrBaseApiSlice,
  daluxfmServerApiSlice,
  daluxIntegrationApiSlice,
  darGraphqlApiSlice,
  datahubIntegrationApiSlice,
  dataIntegrationsApiSlice,
  energyAnalysisApiSlice,
  energySavingsApiSlice,
  expressApiSlice,
  apiSlice as hostApiSlice,
  matGraphqlApiSlice,
  powerbiApiSlice,
  serviceSystemMonitoringApiSlice,
  subscriptionManagerApiSlice,
} from '../api/apiSlice';
// api error handling
import { apiErrorMiddleware } from './apiErrorMiddleware';
import currentUserReducer from './currentUserSlice';
import selectedAccountReducer from './selectedAccountSlice';
import snackbarReducer from './snackbarSlice';
import systemBannerReducer from './systemBannerSlice';

import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

// auth

const staticReducers = {
  [hostApiSlice.reducerPath]: hostApiSlice.reducer, // remoni api v1 slice
  [subscriptionManagerApiSlice.reducerPath]:
    subscriptionManagerApiSlice.reducer,
  [energySavingsApiSlice.reducerPath]: energySavingsApiSlice.reducer,
  [expressApiSlice.reducerPath]: expressApiSlice.reducer,
  [powerbiApiSlice.reducerPath]: powerbiApiSlice.reducer,
  [energyAnalysisApiSlice.reducerPath]: energyAnalysisApiSlice.reducer,
  [authServerApiSlice.reducerPath]: authServerApiSlice.reducer,
  [apiSliceV2.reducerPath]: apiSliceV2.reducer,
  [apiSliceV2Generated.reducerPath]: apiSliceV2Generated.reducer,
  [datahubIntegrationApiSlice.reducerPath]: datahubIntegrationApiSlice.reducer,
  [daluxIntegrationApiSlice.reducerPath]: daluxIntegrationApiSlice.reducer,
  [daluxfmServerApiSlice.reducerPath]: daluxfmServerApiSlice.reducer,
  [dataIntegrationsApiSlice.reducerPath]: dataIntegrationsApiSlice.reducer,
  [cvrBaseApiSlice.reducerPath]: cvrBaseApiSlice.reducer,
  [adminApiSlice.reducerPath]: adminApiSlice.reducer,
  [serviceSystemMonitoringApiSlice.reducerPath]:
    serviceSystemMonitoringApiSlice.reducer,
  [darGraphqlApiSlice.reducerPath]: darGraphqlApiSlice.reducer,
  [matGraphqlApiSlice.reducerPath]: matGraphqlApiSlice.reducer,
  [adressevaelgerApiSlice.reducerPath]: adressevaelgerApiSlice.reducer,
  selectedAccount: selectedAccountReducer,
  currentUser: currentUserReducer,
  snackbar: snackbarReducer,
  systemBanner: systemBannerReducer,
  timeRange: timeRangeReducer,
  dataIntegrity: dataIntegrityReducer,
};

const createReducer = (asyncReducers) =>
  combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });

export const store = configureStore({
  reducer: createReducer({}),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiErrorMiddleware)
      .concat(hostApiSlice.middleware)
      .concat(subscriptionManagerApiSlice.middleware)
      .concat(energySavingsApiSlice.middleware)
      .concat(expressApiSlice.middleware)
      .concat(powerbiApiSlice.middleware)
      .concat(energyAnalysisApiSlice.middleware)
      .concat(authServerApiSlice.middleware)
      .concat(apiSliceV2.middleware)
      .concat(apiSliceV2Generated.middleware)
      .concat(datahubIntegrationApiSlice.middleware)
      .concat(daluxIntegrationApiSlice.middleware)
      .concat(daluxfmServerApiSlice.middleware)
      .concat(dataIntegrationsApiSlice.middleware)
      .concat(cvrBaseApiSlice.middleware)
      .concat(adminApiSlice.middleware)
      .concat(serviceSystemMonitoringApiSlice.middleware)
      .concat(darGraphqlApiSlice.middleware)
      .concat(matGraphqlApiSlice.middleware)
      .concat(adressevaelgerApiSlice.middleware),
});
